import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Clock, Calendar, ArrowRight } from 'lucide-react';
import { blogPosts } from '../mock';

export default function BlogPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main className="blog-page" data-testid="blog-page">
      <section className="blog-index-hero on-dark">
        <div className="wrap">
          <p className="eyebrow">The Victory Journal</p>
          <h1>Plumbing tips, projects &amp; news</h1>
          <p className="lede">Practical advice and seasonal guidance for homeowners and businesses across Savannah &amp; the Coastal Empire.</p>
        </div>
      </section>

      <section className="blog-index">
        <div className="wrap">
          <div className="blog-grid">
            {blogPosts.map((post) => (
              <Link
                className="blog-card"
                to={`/blog/${post.slug}`}
                key={post.slug}
                data-testid={`blog-card-${post.slug}`}
              >
                <div className="blog-card-img" style={{ backgroundImage: `url(${post.image})` }}>
                  <span className="blog-tag">{post.tag}</span>
                </div>
                <div className="blog-card-body">
                  <div className="blog-meta">
                    <span><Calendar size={13} /> {post.date}</span>
                    <span><Clock size={13} /> {post.readTime}</span>
                  </div>
                  <h2>{post.title}</h2>
                  <p>{post.excerpt}</p>
                  <span className="blog-card-link">Read Article <ArrowRight size={15} /></span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
